module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921074149_T.0b9006d3.jpg";